import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config"; 
export const getDashboardData = async () => {
    let token = sessionStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
    let res = await axios({ method: "GET", url: `${process.env.REACT_APP_API_ENDPOINT}dashboard`,headers: { Authorization: token ? `Bearer ${token}` : '', }})
    return res
};